// extracted by mini-css-extract-plugin
module.exports = {"menuLandingWrapper":"MenuLanding_menuLandingWrapper__1gSVH","leftSide":"MenuLanding_leftSide__1H4Sb","rightSide":"MenuLanding_rightSide__Jcz4m"};